/** RoomStatusBadge — room identifier pill for a task card. */

import { useT } from '@hostesa/i18n';
import { StatusBadge } from '@hostesa/ui';
import { asOptionalString } from './task-presentation';

export interface RoomStatusBadgeProps {
  /** The raw `room` field from a ServiceRequest (may be unresolved). */
  room: unknown;
  'data-testid'?: string;
}

/**
 * Shows the room number, or a clear "Room unconfirmed" label when the agent
 * could not establish the room. Never relies on colour alone — the room is text.
 */
export function RoomStatusBadge({ room, 'data-testid': testId }: RoomStatusBadgeProps) {
  const { t } = useT('operations');
  const value = asOptionalString(room);

  if (!value) {
    return (
      <StatusBadge
        status="warning"
        label={t('card.roomUnconfirmed')}
        data-testid={testId ?? 'task-room-unconfirmed'}
      />
    );
  }

  return (
    <StatusBadge
      status="neutral"
      label={`${t('card.room')} ${value}`}
      data-testid={testId ?? 'task-room'}
    />
  );
}
